var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ColumnStyle from './ColumnStyle';
const ParentContext = React.createContext({});
const Column = (_a) => {
    var { children, span } = _a, props = __rest(_a, ["children", "span"]);
    const { parentSpan } = React.useContext(ParentContext);
    return (React.createElement(ParentContext.Provider, { value: { parentSpan: span } },
        React.createElement(ColumnStyle, Object.assign({ parentSpan: parentSpan, span: span }, props), children)));
};
Column.defaultProps = {
    debug: false,
    debugColor: 'rgba(51,102,153,0.5)',
    order: 0,
    push: 0,
    span: 1,
    wrap: false,
};
export default Column;
//# sourceMappingURL=Column.js.map